import AssetDocuments from "./AssetDocuments";

export default function VehicleDocuments({ vehicleId }) {
  return <AssetDocuments ownerType={"VEHICLE"} ownerId={vehicleId} />;
}
